'use strict';

var FlightDateRangeLevelChartAggregationFactory = function FlightDateRangeLevelChartAggregationFactory(FlightThematicDataAggregationFactory, ExtractMetricKeysService, momentService) {
  function FlightDateRangeLevelChartAggregation() {
    FlightThematicDataAggregationFactory.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'date-range-level-chart');
  }
  FlightDateRangeLevelChartAggregation.prototype = Object.create(FlightThematicDataAggregationFactory.prototype);
  FlightDateRangeLevelChartAggregation.constructor = FlightDateRangeLevelChartAggregation;
  FlightDateRangeLevelChartAggregation.prototype.aggregate = function (data, metrics, metricDescriptor) {
    var aggregationFunction = this.getAggregationFunction(metrics, metricDescriptor);
    var metricKeys, keys, keysLength;
    var groupedData = {};
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      if (Array.isArray(groupedData[data[index].flightDepartureDate])) {
        groupedData[data[index].flightDepartureDate].push(data[index]);
      } else {
        groupedData[data[index].flightDepartureDate] = [data[index]];
      }
    }
    keys = Object.keys(groupedData);
    if (keys.length > 0) {
      metricKeys = ExtractMetricKeysService.extract(groupedData[keys[0]][0]);
    }
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      var reducedEntry = {};
      var date = keys[index];
      reducedEntry.departureDate = date;
      reducedEntry.departureDateMoment = momentService.of(date, momentService.FIELD.DEPARTURE_DATE, momentService.FORMAT.DATE).startOf('day');
      aggregationFunction(groupedData[date], metricKeys, reducedEntry);
      groupedData[date] = reducedEntry;
    }
    return this.sortAggregationResults(groupedData);
  };
  return FlightDateRangeLevelChartAggregation;
};
FlightDateRangeLevelChartAggregationFactory.$inject = ['FlightThematicDataAggregationFactory', 'ExtractMetricKeysService', 'MomentService'];
module.exports = FlightDateRangeLevelChartAggregationFactory;